// hooks/useCatalog.ts
import {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {
    archiveBusinessService,
    archiveService,
    selectBusinessServices,
    updateBusinessService,
    updateBusinessServiceCategory,
} from "app/redux/businessServicesSlice";
import {deleteProduct, selectProducts, updateProduct} from "../redux/productSlice";

export type CatalogItem = Service | Product;

const initialProducts: Product[] = [];


const initialProductCategories: Category[] = []

export interface Service {
    id: number;
    type: "service";
    name: string;
    description: string;
    category: string;
    duration: number;
    price: number;
    notes?: string;
    // Each provider's effective price (override or base) for this service
    providerPrices?: { userId: number; providerName: string; price: string; isOverride: boolean }[];
}

export interface Product {
    id: number;          // ✅ changed from string → number
    type: "product";
    duration?:number;
    name: string;
    description: string;
    category: string;
    stock: number;
    price: number;
}

export interface Category {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
    archivedAt: string | null;
}

export interface Categories {
    service: Category[];
    product: Category[];
}


export const useCatalog = () => {
    const dispatch = useDispatch();

    const businessServices = useSelector(selectBusinessServices);

    // const [services, setServices] = useState<Service[]>([])
    const {
        products: a, categories: b, loading, error
    } = useSelector(selectProducts);


    useEffect(() => {

        console.log('prod cats',b)
        console.log('prods',a)
    }, [a,b]);

    const serviceCategories: Category[] = useMemo(() => businessServices.map((category: any) => ({
        id: category.id,
        name: category.name,
        createdAt: category.createdAt,
        updatedAt: category.updatedAt,
        archivedAt: category.archivedAt,
    })), [businessServices])

    // const prodCategories: Category[] = useMemo(() => b.map((category: any) => ({
    //     id: category.id,
    //     name: category.name,
    //     createdAt: category.createdAt,
    //     updatedAt: category.updatedAt,
    //     archivedAt: category.archivedAt,
    // })), [b,a])

    const prodCategories: Category[] = useMemo(() =>
            (b || []).map((category: any) => ({
                id: category.id,
                name: category.name,
                createdAt: category.createdAt,
                updatedAt: category.updatedAt,
                archivedAt: category.archivedAt,
            })),
        [b]
    );




    useEffect(() => {
        console.log('products',a)
        console.log('prod categories',b)

    }, [a,b]);


    useEffect(() => {
        console.log('REDUX PRODUCT CATEGORIES IDS', b.map(c => c.id))
    }, [b]);



    useEffect(() => {
        console.log('bs--', businessServices)
    }, [businessServices]);


    // const [productCategories, setProductCategories] = useState<Category[]>(initialProductCategories);

    // 🟢 UI state
    const [activeTab, setActiveTab] = useState<"services" | "products">(
        "services"
    );
    const [showAddModal, setShowAddModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [showCategoriesModal, setShowCategoriesModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<CatalogItem | null>(null);
    const [editingItem, setEditingItem] = useState<CatalogItem | null>(null);

    const categories: Categories = useMemo(() => ({
        service: serviceCategories,
        product: prodCategories,
    }), [serviceCategories, prodCategories,b,businessServices]);

    const getCategoryColor = (categoryName: string): string => {
        const isServiceCategory = categories.service.some(
            (c) => c.name === categoryName
        );
        const isProductCategory = categories.product.some(
            (c) => c.name === categoryName
        );

        if (isServiceCategory) {
            return "bg-blue-100 text-blue-800 border-blue-200";
        } else if (isProductCategory) {
            return "bg-purple-100 text-purple-800 border-purple-200";
        }
        return "bg-gray-100 text-gray-800 border-gray-200";
    };


    // const handleAddItem = async (newItem: Omit<CatalogItem, "id">) => {
    //     if (newItem.type === "service") {
    //         try {
    //             await dispatch(
    //                 updateBusinessService({
    //                     id: undefined, // let backend create
    //                     name: newItem.name,
    //                     description: newItem.description,
    //                     duration: (newItem as Service).duration,
    //                     priceCents: newItem.price * 100,
    //                 }) as any
    //             ).unwrap();
    //             toast.success("Service added successfully");
    //         } catch (err) {
    //             console.error(err);
    //             toast.error("Failed to add service");
    //         }
    //     } else {
    //         setProducts([
    //             ...products,
    //             { ...newItem, id: Date.now().toString() } as Product,
    //         ]);
    //     }
    //     setShowAddModal(false);
    // };

    // ✅ Edit existing item
    const handleEditItem = async (updatedItem: CatalogItem) => {
        if (updatedItem.type === "service") {
            try {
                const result = await dispatch(
                    updateBusinessService({
                        id: updatedItem.id,
                        title: updatedItem.name,
                        description: updatedItem.description,
                        duration: (updatedItem as Service).duration,
                        priceCents: updatedItem.price * 100,
                        notes: (updatedItem as Service).notes,
                    }) as any
                ).unwrap();

                toast.success("Service updated successfully");
            } catch (err:any) {
                console.error(err);
                toast.error(err?.data?.error ?? "Failed to update service");
            }
            finally {
                setSelectedItem(null); // Force the modal to close and the list to refresh
                setShowViewModal(false);
            }
        }
        else {
            console.log('data to be sent--',updatedItem)
            try {
                const result = await dispatch(
                    updateProduct({productId:updatedItem.id,
                        data:{
                            title: updatedItem.name,
                            description: updatedItem.description,
                            duration: (updatedItem as Product)?.duration,
                            priceCents: updatedItem.price * 100,
                            stock:updatedItem.stock,
                            // productCategoryId:updatedItem.category
                        }
                    }) as any
                ).unwrap();

                toast.success("Product updated successfully");
            } catch (err:any) {
                console.error(err);
                toast.error(err?.data?.error ?? "Failed to update product");
            }
            finally {
                setSelectedItem(null); // Force the modal to close and the list to refresh
                setShowViewModal(false);
            }

        }


    };

    const handleDeleteItem = async (id: number, type: "service" | "product") => {
        if (type === "service") {
            const shouldArchive = window.confirm(
                "Are you sure you want to delete this service?"
            );
            if (!shouldArchive) return;

            try {
                await dispatch(archiveService({id: Number(id)}) as any).unwrap();
                toast.success("Service archived successfully");
            } catch (err) {
                console.error(err);
                toast.error("Failed to archive service");
            }
        } else if (type==='product') {
            const shouldArchive = window.confirm(
                "Are you sure you want to delete this Product?"
            );
            if (!shouldArchive) return;

            try {
                await dispatch(deleteProduct({id: Number(id)}) as any).unwrap();
                toast.success("Product archived successfully");
            } catch (err) {
                console.error(err);
                toast.error("Failed to archive product");
            }

        }
    };

    const handleEditCategory = async (categoryId: number, name: string) => {
        try {
            await dispatch(
                updateBusinessServiceCategory({id: categoryId, name}) as any
            ).unwrap();
            toast.success("Category updated successfully");
        } catch (err) {
            console.error(err);
            toast.error("Failed to update category");
        }
    };

    const handleDeleteCategory = async (categoryId: number, categoryName: string) => {
        const shouldArchive = window.confirm(
            `Are you sure you want to delete all services in the ${categoryName} category?`
        );
        if (!shouldArchive) return;

        try {
            await dispatch(archiveBusinessService({id: categoryId}) as any).unwrap();
            toast.success("Category archived successfully");
        } catch (err) {
            console.error(err);
            toast.error("Failed to archive category");
        }
    };



    // useEffect(() => {
    //     console.log('businessServices here',businessServices)
    //
    //     const newServices = businessServices.flatMap((category) => {
    //             if (category?.services?.length > 0) {
    //                return  category?.services?.map((s: any) => ({
    //                     id: s.id, // keep as number for consistency
    //                     type: "service",
    //                     name: s.title,
    //                     description: s.description ?? "",
    //                     category: category.name,
    //                     duration: s.duration,
    //                     price: s.priceCents / 100,
    //                 }))
    //             } else return []
    //         }
    //     )
    //     const newProducts = a.flatMap((item: any) =>
    //         ({
    //             id: item.id,
    //             type: "product",
    //             name: item.title,
    //             description: item.description ?? "",
    //             category: item.productCategory?.name,
    //             duration: item.duration,
    //             stock: item.stock,
    //             price: item.priceCents / 100,
    //         })
    //     )
    //     console.log('service now',newServices)
    //     setServices(newServices)
    //     setProducts(newProducts as any)
    //
    //     console.log('products in effect',a,newProducts)
    //     console.log('productcats',productCategories)
    //
    // }, [businessServices, a, b]);



    const services: Service[] = useMemo(() => {
        return businessServices.flatMap((category) => {
            // Use optional chaining and fallback to empty array
            return (category?.services || []).map((s: any) => ({
                id: s.id,
                type: "service",
                name: s.title,
                description: s.description ?? "",
                category: category.name,
                duration: s.duration,
                price: s.priceCents / 100,
                notes: s.notes ?? "",
                providerPrices: s.providerPrices ?? [],
            }));
        });
    }, [businessServices]); // This will re-run automatically when Redux updates

    // ✅ ADD THIS
// derived directly from Redux state 'a'
    const products: Product[] = useMemo(() => {
        // Safety check: ensure 'a' exists before mapping
        return (a || []).map((item: any) => ({
            id: item.id, // keep as number
            type: "product",
            name: item.title,
            description: item.description ?? "",
            // precise safety check for nested category object
            category: item.productCategory?.name ?? "Uncategorized",
            duration: item.duration,
            stock: item.stock,
            price: (item.priceCents || 0) / 100,
        }));
    }, [a,b]);


    const currentItems = useMemo(()=>activeTab === "services" ? services : products,[activeTab,services,products]) ;

    return {
        // state
        activeTab,
        services,
        categories,
        serviceCategories,
        // productCategories,
        products,
        showAddModal,
        showViewModal,
        showBulkUploadModal,
        showCategoriesModal,
        selectedItem,
        editingItem,
        // managedCategories,
        currentItems,

        // actions
        setActiveTab,
        setShowAddModal,
        setShowViewModal,
        setShowBulkUploadModal,
        setShowCategoriesModal,
        setSelectedItem,
        setEditingItem,
        // setManagedCategories,
        // setProductCategories,
        // handleAddItem,
        handleEditItem,
        handleDeleteItem,
        handleEditCategory,
        handleDeleteCategory,
        getCategoryColor,
    };
};
